type PropsTypeObj = {
    [x: string]: object | [] | FormDataEntryValue | string | number | null;
};

const isSameDataInObjects = (
    obj1: PropsTypeObj,
    obj2: PropsTypeObj,
): boolean => {
    // Helper function to recursively compare objects
    function deepCompare(o1, o2) {
        // If both are arrays, compare them element-wise
        if (Array.isArray(o1) && Array.isArray(o2)) {
            if (o1.length !== o2.length) {
                return false; // Arrays have different lengths
            }
            for (let i = 0; i < o1.length; i++) {
                if (!deepCompare(o1[i], o2[i])) {
                    return false; // Recursive comparison failed
                }
            }
            return true; // Arrays are equal
        }

        // If both are objects, compare their keys
        if (
            typeof o1 === 'object' &&
            typeof o2 === 'object' &&
            o1 !== null &&
            o2 !== null
        ) {
            const keys1 = Object.keys(o1);
            const keys2 = Object.keys(o2);

            // Ensure both objects have the same keys
            if (
                keys1.length !== keys2.length ||
                !keys1.every((key) => keys2.includes(key))
            ) {
                return false;
            }

            // Compare values recursively based on shared keys
            for (const key of keys1) {
                if (!deepCompare(o1[key], o2[key])) {
                    return false; // Recursive comparison failed
                }
            }
            return true; // Objects are equal
        }

        // Compare primitive values directly
        return o1 === o2;
    }

    // Get keys from obj1
    const keys = Object.keys(obj1);

    // Iterate through keys
    for (const key of keys) {
        // Check if obj2 also has the key
        if (obj2.hasOwnProperty(key)) {
            const value1 = obj1[key];
            const value2 = obj2[key];

            // Compare values based on type and structure
            if (!deepCompare(value1, value2)) {
                return false; // Found a difference
            }
        }
    }

    // If all comparisons passed, objects are considered equal
    return true;
};

export default isSameDataInObjects;
